import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import focusable from '../../components/Focusable/Focusable'
import Spinner from '../../components/Spinner/Spinner'
import Grid from '../../components/Grid/Grid'
import * as UI from '../../lib/ui'
import tts from '../../lib/TTS'
import { getCollections } from '../../actions/contentActions'
import { contentServiceGet } from '../../lib/utils.js'
import { store } from '../../store'
import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers.js'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class SeeAllScreen extends React.Component {
  constructor(props) {
    super(props)

    this.header = this.props.router.params.header

    this.state = {
      id: 'SeeAllScreen',
      spinnerVisible: true,
      collection: null,
      itemType: null,
      nextDataUrl: null,
      gettingNextData: false,
      collectionContentAvailable: false,
    }
    this.handleNearEndOfGrid = this.handleNearEndOfGrid.bind(this)
    UI.setLoadingState(true)
  }

  onKeyEvent(key) {
    let handled = false
    if (this.props.loading || this.state.spinnerVisible) {
      return
    }

    if ('BACK' === key) {
      this.props.router.navigate(-1)
    }

    return handled
  }

  componentDidMount() {
    const link = decodeURIComponent(this.props.router.params.url)
    UI.registerFocusableComponent({ screen: this.state.id })
    UI.setSidePanelVisibility(false)
    this.requestContent(link)
    tts.pushTextToRead(this.header)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.itemType !== this.state.itemType && this.state.itemType) {
      const formattedContent =
        this.state.itemType.slice(0, 1).toUpperCase() +
        this.state.itemType.slice(1) +
        's'
      googleAnalytics4.sendPageViewEvent(
        `See All ${formattedContent} | ${this.header}`
      )
    }
  }

  getNextData() {
    if (this.state.gettingNextData) return
    if (this.state.nextDataUrl && this.state.nextDataUrl.length > 0) {
      this.setState({ gettingNextData: true })
      return contentServiceGet(this.state.nextDataUrl)
        .then((resp) => {
          this.setState({
            nextDataUrl: resp.meta.links.next || null,
            collection: this.state.collection.concat(
              resp.collections[0].content
            ),
            gettingNextData: false,
          })

          UI.setLoadingState(false)
        })
        .catch((err) => {
          const errorMessage = `Error ${
            err.status ? err.status : '(unknown)'
          } on Search screen requesting additional content content from ${
            this.state.nextDataUrl
          }`

          triggerSentryError('getNextData', 'SeeAllScreen.js', {
            error: err,
            errorMessage,
            errorLocation: 'SeeAllScreen - getNextData',
            errorType: ComcastErrorType.network,
          })

          this.setState({
            nextDataUrl: null,
            gettingNextData: false,
          })
        })
    }
  }

  requestContent(link) {
    const url = decodeURIComponent(link)

    getCollections(url, `seeall-${this.header}-screen-${link}`)
      .then((collectionsResponse) => {
        const { collections, meta } = collectionsResponse
        const next = meta.links.next

        if (collections[0]) {
          this.setState(
            {
              spinnerVisible: false,
              collection: collections[0].content,
              itemType: collections[0].item_type,
              collectionContentAvailable: true,
            },
            () => {
              UI.setLoadingState(false)
              this.grid?.setFocus()
            }
          )

          if (null !== next) {
            this.setState({
              nextDataUrl: next,
            })
          }
        } else {
          UI.setLoadingState(false)
          this.setState(
            {
              spinnerVisible: false,
              collectionContentAvailable: false,
            },
            () => {
              UI.setLoadingState(false)
            }
          )

          const errorObject = {
            status: 'NoSeeAllContent',
            code: 'Unable to load content',
            content: {},
            codeBaseLocation: '',
            errorType: '',
          }

          store.dispatch({
            type: 'TRIGGER_ERROR',
            payload: {
              error: {
                ...errorObject,
                content: {
                  error: errorObject,
                  errorPath: this.props.router.location.pathname,
                },
                codeBaseLocation: 'SeeAllScreen - requestContent - noContent',
                errorType: ComcastErrorType.other,
              },
            },
          })

          this.props.router.navigate('/error', { replace: true })
        }
      })
      .catch((error) => {
        UI.setLoadingState(false)
        store.dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error: {
              content: {
                error,
                errorPath: this.props.router.location.pathname,
              },
              codeBaseLocation: 'SeeAllScreen - requestContent',
              errorType: ComcastErrorType.network,
            },
          },
        })

        this.props.router.navigate('/error', { replace: true })
      })
  }

  setGridRef(grid) {
    if (null !== grid) {
      this.grid = grid
    }
  }

  handleNearEndOfGrid() {
    this.getNextData()
  }

  render() {
    const {
      collection,
      collectionContentAvailable,
      spinnerVisible,
      itemType,
      gettingNextData,
    } = this.state

    return (
      <>
        <Spinner visible={spinnerVisible} screen={true} />
        <div
          style={{
            position: 'absolute',
            top: '400px',
            width: '10px',
            height: '10px',
            zIndex: '1',
          }}
        >
          <Spinner visible={gettingNextData} />
        </div>

        {!spinnerVisible && collectionContentAvailable && (
          <Grid
            view={itemType}
            collectionType={
              itemType === 'skylab-collection' ? 'all' : undefined
            }
            handleNearEndOfGrid={this.handleNearEndOfGrid}
            collection={collection}
            parent={this}
            ref={(grid) => {
              this.setGridRef(grid)
            }}
          />
        )}
      </>
    )
  }
}

SeeAllScreen.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func,
    replace: PropTypes.func,
    params: PropTypes.shape({
      header: PropTypes.string,
      url: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  loading: PropTypes.bool,
  favorites: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  favoritesFullyLoaded: PropTypes.bool,
  watchlist: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  watchlistFullyLoaded: PropTypes.bool,
  uid: PropTypes.string,
  collectionContentAvailable: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    loading: state.loading.loadingScreen,
    stationId: state.station.station_id,
    ui: state.ui,
    uid: state.device.UID,
    favorites: state.personalization.favorites,
    favoritesFullyLoaded: state.personalization.favoritesFullyLoaded,
    watchlist: state.personalization.watchlist,
    watchlistFullyLoaded: state.personalization.watchlistFullyLoaded,
  }
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(SeeAllScreen)))
